import React from "react";
import CardContent from "../../components/CardContent/CardContent";
import ImageCard from "../../components/ImageCard/ImageCard";
import IsDesktop from "../../components/IsDesktop/IsDesktop";
import IsMobile from "../../components/IsMobile/IsMobile";
import { useLanguage } from "../../i18n/LanguageContext";
import { CardListLayout, GenericCardFields } from "../../model/common";
import { BreakpointValues } from "../Image/Image";
import { internalLinkUrl } from "../InternalLink/InternalLink";

interface GenericCardProps {
  card: GenericCardFields;
  readMore?: boolean;
  layout?: CardListLayout;
  textMaxLines?: number;
  widths?: BreakpointValues;
  titleAs?: string;
}

const GenericCard = ({
  card,
  layout,
  readMore = true,
  textMaxLines = -1,
  widths = layout === "stretch" ? 405 : 270,
  titleAs
}: GenericCardProps) => {
  const language = useLanguage();
  const url = card.internalLink
    ? internalLinkUrl(
        card.internalLink.reference,
        card.internalLink.query,
        card.internalLink.fragment,
        language
      )
    : card.externalLink!;
  const createCardWithImage = (isMobile: boolean): JSX.Element => {
    const image =
      isMobile && card.mobileImage ? card.mobileImage : card.desktopImage;
    return (
      <ImageCard
        key={card._key}
        image={image}
        widths={widths}
        aspectRatio={image.asset.metadata.dimensions.aspectRatio}
        overlay={card.titleOverImage ? card.title : undefined}
        href={url}
      >
        <CardContent
          titleAs={titleAs}
          title={card.titleOverImage ? undefined : card.title}
          text={card.description}
          href={url}
          readMore={readMore}
          textMaxLines={textMaxLines}
        />
      </ImageCard>
    );
  };
  return (
    <>
      <IsMobile>{createCardWithImage(true)}</IsMobile>
      <IsDesktop>{createCardWithImage(false)}</IsDesktop>
    </>
  );
};

export default GenericCard;
